import $ from 'jquery';

$(function () {
    function scrollToElement(element) {
        if (element.length > 0) {
            let offset = element.offset().top;
            window.scrollTo({
                left: 0,
                top: offset,
                behavior: 'smooth'
            });
        }
    }

    // Clicking on link that targets an anchor on current page
    $('a[href*=\\#]:not(.skip-navigation)').on('click', function (event) {
        event.preventDefault();
        scrollToElement($(this.hash));
    });
});
